<template>
  <div class="quantity-control-wrapper">
    <!-- 左侧数量控制区域 -->
    <div class="quantity-control">
      <span 
        class="quantity-btn minus" 
        @click="decreaseQuantity"
        :class="{ disabled: quantity <= 1 }"
      ></span>
      <span 
        class="quantity-display" 
        @click="showQuantityUpdate"
      >
        {{ quantity }}
      </span>
      <span 
        class="quantity-btn plus" 
        @click="increaseQuantity"
      ></span>
    </div>
    
    <!-- 右侧删除按钮 -->
    <div class="delete-control">
      <span 
        class="delete-btn" 
        @click="showDeleteConfirm"
      ></span>
    </div>

    <!-- 修改数量弹窗 -->
    <van-popup v-model="showQuantityPopup" :lock-scroll="true">
      <div class="quantity-popup-wrapper">
        <div class="quantity-popup-block">
          <h1>修改数量</h1>
          <input
            type="number"
            oninput="if(value.length>4)value=value.slice(0,4)"
            v-model="newQuantity"
            placeholder="请输入数量"
            @focus="selectAll"
          />
          <button @click="confirmQuantityUpdate">确认</button>
          <span @click="cancelQuantityUpdate">取消</span>
        </div>
      </div>
    </van-popup>

    <!-- 删除确认弹窗 -->
    <van-popup v-model="showDeletePopup" :lock-scroll="true">
      <div class="delete-popup-wrapper">
        <div class="delete-popup-block">
          <p class="delete-title">删除商品</p>
          <p class="delete-message">是否确认删除该商品？</p>
          <div class="delete-confirm" @click="confirmDelete">
            <p>确认</p>
          </div>
          <div class="delete-cancel" @click="cancelDelete">取消</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast, Popup } from 'vant'

export default {
  name: 'QuantityControl',
  components: {
    [Popup.name]: Popup
  },
  props: {
    quantity: {
      type: Number,
      required: true,
      default: 1
    },
    minQuantity: {
      type: Number,
      default: 1
    },
    maxQuantity: {
      type: Number,
      default: 9999
    },
    productName: {
      type: String,
      default: '该商品'
    }
  },
  data() {
    return {
      showQuantityPopup: false,
      showDeletePopup: false,
      newQuantity: 1
    }
  },
  methods: {
    // 增加数量
    increaseQuantity() {
      if (this.quantity >= this.maxQuantity) {
        Toast(`最多只能选择${this.maxQuantity}件`)
        return
      }
      this.$emit('quantity-change', this.quantity + 1)
    },

    // 减少数量
    decreaseQuantity() {
      if (this.quantity <= this.minQuantity) {
        Toast(`最少需要${this.minQuantity}件`)
        return
      }
      this.$emit('quantity-change', this.quantity - 1)
    },

    // 显示数量修改弹窗
    showQuantityUpdate() {
      this.newQuantity = this.quantity
      this.showQuantityPopup = true
    },

    // 确认修改数量
    confirmQuantityUpdate() {
      const qty = parseInt(this.newQuantity)
      if (!qty || qty < this.minQuantity) {
        Toast(`数量不能少于${this.minQuantity}`)
        return
      }
      if (qty > this.maxQuantity) {
        Toast(`数量不能超过${this.maxQuantity}`)
        return
      }
      
      this.$emit('quantity-change', qty)
      this.showQuantityPopup = false
    },

    // 取消修改数量
    cancelQuantityUpdate() {
      this.showQuantityPopup = false
      this.newQuantity = this.quantity
    },

    // 显示删除确认弹窗
    showDeleteConfirm() {
      this.showDeletePopup = true
    },

    // 确认删除
    confirmDelete() {
      this.$emit('delete')
      this.showDeletePopup = false
    },

    // 取消删除
    cancelDelete() {
      this.showDeletePopup = false
    },

    // 选中输入框内容
    selectAll(event) {
      event.target.select()
    }
  }
}
</script>

<style scoped lang="scss">
.quantity-control-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 0;
}

.quantity-control {
  display: flex;
  align-items: center;
  
  .quantity-btn {
    display: inline-block;
    width: 59px;
    height: 41px;
    cursor: pointer;
    
    &.minus {
      background: url('~@/assets/img/cart/sub.png') center center no-repeat;
      background-size: contain;
      
      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
    
    &.plus {
      background: url('~@/assets/img/cart/add.png') center center no-repeat;
      background-size: contain;
    }
  }
  
  .quantity-display {
    background: #f0f4f7;
    border-radius: 10px;
    text-align: center;
    width: 120px;
    height: 40px;
    margin: 0 7px;
    font-size: 28px;
    color: #999999;
    line-height: 40px;
    cursor: pointer;
    
    &:hover {
      background: #e8f2f7;
    }
  }
}

.delete-control {
  margin-left: 60px; /* 保持与plus按钮的距离，避免误操作 */
  
  .delete-btn {
    display: inline-block;
    width: 64px;
    height: 40px;
    background: url('~@/assets/img/cart/del.png') center center no-repeat;
    background-size: contain;
    cursor: pointer;
  }
}

/* 修改数量弹窗样式 */
.quantity-popup-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.quantity-popup-block {
  width: 540px;
  height: 440px;
  background-color: #fff;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 40px 41px 32px 41px;

  h1 {
    color: #000000;
    line-height: 54px;
    font-weight: bold;
    font-size: 32px;
    margin: 0;
  }

  input {
    width: 460px;
    height: 80px;
    border: 1px solid #dce4eb;
    padding-left: 14px;
    font-size: 32px;
    border-radius: 8px;

    &::placeholder {
      color: #909397;
    }

    &:focus {
      outline: none;
      border-color: #50cc73;
    }
  }

  button {
    border: none;
    outline: none;
    width: 100%;
    height: 80px;
    background: linear-gradient(330deg, #2fb555 0%, #50cc73 100%);
    border-radius: 40px;
    font-size: 32px;
    color: #ffffff;
    font-weight: 500;
    cursor: pointer;
    
    &:hover {
      opacity: 0.9;
    }
  }

  span {
    font-size: 30px;
    color: #909397;
    cursor: pointer;
    
    &:hover {
      color: #666;
    }
  }
}

/* 删除确认弹窗样式 */
.delete-popup-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-popup-block {
  width: 540px;
  height: 360px;
  background-color: #fff;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 40px 41px 32px 41px;

  .delete-title {
    color: #000000;
    line-height: 54px;
    font-weight: bold;
    font-size: 32px;
    margin: 0;
  }

  .delete-message {
    color: #333333;
    font-size: 28px;
    margin: 20px 0;
    text-align: center;
  }

  .delete-confirm {
    width: 100%;
    height: 80px;
    background: linear-gradient(330deg, #ff4444 0%, #ff6666 100%);
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-bottom: 16px;
    
    &:hover {
      opacity: 0.9;
    }

    p {
      font-size: 32px;
      color: #ffffff;
      font-weight: 500;
      margin: 0;
    }
  }

  .delete-cancel {
    font-size: 30px;
    color: #909397;
    cursor: pointer;
    
    &:hover {
      color: #666;
    }
  }
}
</style> 


// WEBPACK FOOTER //
// src/components/QuantityControl/QuantityControl.vue